module.exports = __webpack_public_path__ + "static/media/google.27ba7c0d.svg";